import { QueryClient } from "@tanstack/react-query";

/**
 * Создаёт новый экземпляр QueryClient (не singleton).
 * В App Router для клиентского провайдера экземпляр держится в useState на клиенте,
 * чтобы не разделять кэш между разными пользователями/запросами на сервере.
 */
export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
      },
    },
  });
}
